module.exports = __webpack_public_path__ + "static/media/rotate.aaa7d450.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/EditProfile/rotate.png
// module id = 605
// module chunks = 0